import { getGlobalLookup } from "@faire/web--source/common/globals/lookup";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";

export const availableLanguageSelectorLocales = (getGlobalLookup()<
  ILocaleKey[]
>("availableLanguageSelectorLocales") as ILocaleKey[]) ?? [
  ILocaleKey.build({ country: "USA", language: "ENG" }),
];
